var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSlack = function SvgSlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 123 123",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 78.8c0 6.8-5.5 12.3-12.3 12.3S1.2 85.6 1.2 78.8s5.5-12.3 12.3-12.3h12.3v12.3zm6.2 0c0-6.8 5.5-12.3 12.3-12.3s12.3 5.5 12.3 12.3v30.7c0 6.8-5.5 12.3-12.3 12.3s-12.3-5.5-12.3-12.3V78.8z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3 25.8c-6.8 0-12.3-5.5-12.3-12.3S37.5 1.2 44.3 1.2s12.3 5.5 12.3 12.3v12.3H44.3zm0 6.2c6.8 0 12.3 5.5 12.3 12.3s-5.5 12.3-12.3 12.3H13.6C6.8 56.6 1.3 51.1 1.3 44.3s5.5-12.3 12.3-12.3h30.7z",
    fill: "#36C5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4 44.3c0-6.8 5.5-12.3 12.3-12.3s12.3 5.5 12.3 12.3-5.5 12.3-12.3 12.3H97.4V44.3zm-6.2 0c0 6.8-5.5 12.3-12.3 12.3s-12.3-5.5-12.3-12.3V13.6c0-6.8 5.5-12.3 12.3-12.3s12.3 5.5 12.3 12.3v30.7z",
    fill: "#2EB67D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9 97.4c6.8 0 12.3 5.5 12.3 12.3s-5.5 12.3-12.3 12.3-12.3-5.5-12.3-12.3V97.4h12.3zm0-6.2c-6.8 0-12.3-5.5-12.3-12.3s5.5-12.3 12.3-12.3h30.7c6.8 0 12.3 5.5 12.3 12.3s-5.5 12.3-12.3 12.3H78.9z",
    fill: "#ECB22E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slack.506fb03b.svg";
export { ForwardRef as ReactComponent };